export const AGI_DOMAINS = ["agi.centiloquy.com", "localhost"];

export const isAgiDomain = () => {
    return AGI_DOMAINS.includes(window.location.hostname);
};
